
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const designcategoryApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listDesignCategories: builder.query ({
      query: (params) => `v2/designcategory/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["DesignCategory"]
    }),
    getDesignCategory: builder.query ({
      query: (designcategory_id) => `v2/designcategory/${designcategory_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["DesignCategory"]
    }),
    getDesignCategoryDesigns: builder.query ({
      query: (designcategory_id) => `v2/design/?category=${designcategory_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Design"]
    }),
    updateDesignCategory: builder.mutation ({
      query: ({designcategory_id, data}) => ({
        url: `v2/designcategory/${designcategory_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["DesignCategory"]
    }),
    deleteDesignCategory: builder.mutation ({
      query: (designcategory_id) => ({
        url: `v2/designcategory/${designcategory_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["DesignCategory"]
    }),
    createDesignCategory: builder.mutation ({
      query: (data) => ({
        url: `v2/designcategory/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["DesignCategory"]
    }),
  })
})


export const {
  useListDesignCategoriesQuery,
  useLazyListDesignCategoriesQuery,
  useGetDesignCategoryQuery,
  useLazyGetDesignCategoryQuery,
  useGetDesignCategoryDesignsQuery,
  useUpdateDesignCategoryMutation,
  useDeleteDesignCategoryMutation,
  useCreateDesignCategoryMutation
} = designcategoryApi
